var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.564 12.948h.216l.097-.193 1.65-3.284a3.85 3.85 0 013.44-2.121h10.54a3.85 3.85 0 013.444 2.129l1.638 3.276.096.193h4.948a6.65 6.65 0 016.65 6.65V42a6.65 6.65 0 01-6.65 6.65h-30.8A6.65 6.65 0 016.183 42V19.598a6.65 6.65 0 016.65-6.65h4.73zm17.508-2.53l-.313.156.313-.156a1.75 1.75 0 00-1.565-.968h-10.54a1.75 1.75 0 00-1.563.964l-2.039 4.056a1.05 1.05 0 01-.938.578h-5.594a4.55 4.55 0 00-4.55 4.55V42a4.55 4.55 0 004.55 4.55h30.8a4.55 4.55 0 004.55-4.55V19.598a4.55 4.55 0 00-4.55-4.55h-5.597a1.05 1.05 0 01-.939-.58l-2.025-4.05zM17.37 29.4c0-5.992 4.858-10.85 10.85-10.85s10.85 4.858 10.85 10.85-4.858 10.85-10.85 10.85-10.85-4.858-10.85-10.85zm10.85-8.75a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5z",
    fill: "#D7DAE0",
    stroke: "#fff",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M.5.5h55v55H.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoPlaceholder);
export default __webpack_public_path__ + "static/media/PhotoPlaceholder.88462357dacdcd5200909fee3eed6acb.svg";
export { ForwardRef as ReactComponent };